<template>
  <section class="mb-14 md:mb-16">
    <CatalogFilterHeader>
      <template #title>
        {{ category.name }}
      </template>

      <template #toolbar>
        <CatalogFilterHeaderFilters
          :is-filters-open="showFilters.desktop"
          @toggle-filters="toggleFilters"
        />
        <CatalogFilterHeaderSorting v-model="sortingValue" />
      </template>
    </CatalogFilterHeader>

    <div class="py-6 md:py-12">
      <div class="container">
        <div class="flex">
          <div
            v-show="showFilters.desktop"
            class="hidden flex-shrink-0 basis-[260px] pr-4 md:block lg:basis-[324px] xl:basis-[444px]"
          >
            <slot name="filter" />
          </div>

          <UiDrawer
            v-model="showFilters.mobile"
            title="Filters"
            class="md:hidden"
          >
            <template #default>
              <slot name="filter" />
            </template>
            <template #footer="{ close }">
              <UiButton block size="md" @click="close">
                {{ $t('apply_filters') }}
              </UiButton>
            </template>
          </UiDrawer>

          <div class="relative w-full">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed, reactive } from 'vue';
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core';
import CatalogFilterHeader from '~/domains/catalog/components/CatalogFilterHeader.vue';
import CatalogFilterHeaderSorting from '~/domains/catalog/components/CatalogFilterHeaderSorting.vue';
import CatalogFilterHeaderFilters from '~/domains/catalog/components/CatalogFilterHeaderFilters.vue';

interface Props {
  category?: any;
  sorting?: any;
}
interface Emits {
  (e: 'update:sorting', data: Props['sorting']): void;
}

const props = withDefaults(defineProps<Props>(), {
  category: () => ({}),
  sorting: () => ({}),
});
const emit = defineEmits<Emits>();

const { isGreater } = useBreakpoints(breakpointsTailwind);
const showFilters = reactive({
  desktop: true,
  mobile: false,
});

const sortingValue = computed({
  get() {
    return props.sorting;
  },
  set(value) {
    emit('update:sorting', value);
  },
});

const toggleFilters = () => {
  const bp = isGreater('lg') ? 'desktop' : 'mobile';
  showFilters[bp] = !showFilters[bp];
};
</script>
